// @ts-nocheck
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Selectors from '../../../../selectors'
import { isBrowser, isTablet } from 'react-device-detect'
import _ from 'lodash'

import Form from '../..'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import { colors } from '@lmc/common/constants'
import { getNominative } from '../../../../common/utils'
import { ErrorBox, Spinner, IconSectionHeader } from '../../../generic'
import Field from '../../../fields'
import RiskAssessmentOutcome from './RiskAssessmentOutcome'
import { AssessmentEditableHeader } from '../../../modals/CreateRiskAssessment/components'
import FormFields from '../../FormFields'
import { withRouter } from '../../../../withRouter'
import MultiSelectField from '../../../fields/types/MultiSelectField'
import { Text } from '@lmc/ui-kit'
import { ImageSection } from '../../../generic/ListItem/components'
import { Modal } from '@lmc/ui-kit'
import RiskAssessmentEditFooter from 'screens/Residents/screens/ResidentRiskAssessmentsScreens/components/RiskAssessmentEditFooter'
import { ContingencyPlanSelector } from 'components/generic/ContingencyPlanSelector/ContingencyPlanSelector'

const isDesktop = isBrowser || isTablet

export class RiskAssessmentForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      carePlans: [],
      carePlansDefault: [],
      contingencyPlans: [],
      contingencyPlansDefault: [],
      isModalVisible: false
    }
    this.form = null
  }

  componentDidMount() {
    const {
      fetchList,
      carePlanAdls,
      loadListItem,
      form,
      form_id,
      fetchCarePlan,
      carePlansDefault
    } = this.props

    if (!carePlanAdls) {
      fetchList('care-plan-adls')
    }

    loadListItem('forms', form_id)
    if (form) {
      this.addForm(form)
    }

    const { features, router } = this.props

    const id = router?.params?.id

    if (features && id) {
      fetchCarePlan(id)
    }

    const carePlansDefaultWithSupport = carePlansDefault?.filter(
      (carePlan) => !carePlan.noFurtherSupportRequired
    )
    const hasDefaultValues = carePlansDefaultWithSupport?.length

    if (hasDefaultValues) {
      this.setState({ carePlans: carePlansDefaultWithSupport })
      this.setState({ carePlansDefault: carePlansDefaultWithSupport })
    }

    if (
      this.props.isRiskAssessmentFuturePlanEnabled &&
      this.props.contingencyPlansDefault?.length
    ) {
      const { contingencyPlansDefault } = this.props
      this.setState({ contingencyPlans: contingencyPlansDefault })
      this.setState({ contingencyPlansDefault })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      features,
      router: {
        params: { id }
      },
      fetchCarePlan
    } = this.props
    if (features && id !== nextProps.router.params.id) {
      fetchCarePlan(nextProps.router.params.id)
    }
  }

  componentDidUpdate(prev) {
    if (this.props.form && !prev.form) {
      this.addForm(this.props.form)
    }
  }

  addForm(form) {
    const { addForm, customName, formData, setFormField } = this.props
    addForm({
      ...formData,
      carePlanAdl: form.carePlanAdl || null
    })
    setFormField({ key: 'name', value: customName || null })
  }

  setFormRef = (element) => (this.form = element)

  getFields = (data) => {
    const formData = _.keyBy(data.formData, 'key')
    return data.form.formFields.map((field) => ({
      ...field,
      value: formData[field.key]
    }))
  }

  hasChangedCarePlans = () =>
    JSON.stringify(
      this.state.carePlansDefault?.sort((a, b) => a.name - b.name)
    ) !== JSON.stringify(this.state.carePlans?.sort((a, b) => a.name - b.name))

  getContingencyPlanId = (plan) => (typeof plan === 'string' ? plan : plan.id)

  hasChangedContingencyPlans = () =>
    !this.props.isRiskAssessmentFuturePlanEnabled
      ? false
      : JSON.stringify(
          this.state.contingencyPlansDefault
            ?.map(this.getContingencyPlanId)
            ?.sort((a, b) => a.localeCompare(b))
        ) !==
        JSON.stringify(
          this.state.contingencyPlans
            ?.map(this.getContingencyPlanId)
            ?.sort((a, b) => a.localeCompare(b))
        )

  handleSubmit = () => {
    const {
      createItem,
      form,
      form_id,
      onCancel,
      onComplete,
      initial,
      router: { params },
      risk,
      riskAssessmentId,
      updateItem
    } = this.props

    const fields = this?.props?.fields
    const contingencyPlansPayload =
      this.props.isRiskAssessmentFuturePlanEnabled ||
      !!this.props.linkedContingencyPlanId
        ? Array.from(
            new Set([
              ...(this.state.contingencyPlans?.map(this.getContingencyPlanId) || []),
              ...(this.props.linkedContingencyPlanId
                ? [this.props.linkedContingencyPlanId]
                : [])
            ])
          )
        : undefined

    if (
      !_.isEqual(fields, initial) ||
      this.hasChangedCarePlans() ||
      this.hasChangedContingencyPlans() ||
      !!this.props.linkedContingencyPlanId
    ) {
      const chosenId = form_id || params.form_id

      const name = fields?.name
        ? `${form?.name} for ${fields?.name}`
        : undefined

      const carePlansChoosen = !!this.state.carePlans.length

      createItem({
        url: `list/risk-assessments`,
        json: {
          form: chosenId,
          formData: fields,
          name,
          resident: params.id,
          riskLevel: risk.level,
          riskScore: risk.score,
          carePlans: carePlansChoosen
            ? this.state.carePlans?.map((item) => item?.value || item?.id)
            : [],
          contingencyPlans: contingencyPlansPayload
        },
        formId: FORM_ID,
        onError: (e) => {
          console.log('onError', e)
          this?.form?.scrollIntoView({ behavior: 'smooth' })
        },
        onComplete: (res) => {
          if (!params?.risk_assessment_id) {
            onComplete(res)
          } else {
            this.props.router.navigate(
              `/residents/${params.id}/risk-assessments/${res.id}`,
              { replace: true }
            )
          }
        }
      })
    } else if (riskAssessmentId) {
      updateItem({
        url: `list/risk-assessments/${riskAssessmentId}`,
        formId: FORM_ID,
        onError: (e) => {
          console.log('onError', e)
          this.form?.scrollIntoView({ behavior: 'smooth' })
        },
        onComplete: (res) => {
          if (!params?.risk_assessment_id) {
            onComplete(res)
          } else {
            this.props.router.navigate(
              `/residents/${params.id}/risk-assessments/${res.id}`,
              { replace: true }
            )
          }
        }
      })
    } else {
      onCancel()
    }
  }

  setCustomName = (e) => {
    this.props.setFormField({
      key: 'name',
      value: e.target.value
    })
  }

  handleCarePlanIds = (value) => {
    this.setState({ carePlans: value })
  }

  handleContingencyPlanIds = (value) => {
    this.setState({ contingencyPlans: value })
  }

  carePlanSelectOption = ({ name, icon, color }) => (
    <div style={styles.wrapper}>
      <ImageSection popup iconColor={color} icon={icon} />
      <span style={styles.name}>{name}</span>
    </div>
  )

  renderFields = () => {
    const { form, fields, carePlans, carePlanAdls, carePlanNominative } =
      this.props

    const carePlansAdlsSelection = carePlans?.adls || carePlanAdls || []

    const carePlanOptions = carePlansAdlsSelection
      ?.filter(
        (item) =>
          item?.carePlan &&
          !item?.carePlan?.noFurtherSupportRequired &&
          item?.carePlan?.nextReviewDate
      )
      .map((item) => ({
        id: item.carePlan?.id,
        name: item.name,
        icon: item?.icon,
        color: item?.color
      }))

    if (!form || !form.formFields) return null

    const carePlansChoosen = this.state.carePlans?.length

    const carePlansOptios = carePlanOptions?.length

    return (
      <>
        <div
          style={{
            marginTop: 10,
            background: colors.white,
            borderRadius: 15,
            padding: 15,
            display: 'flex'
          }}
        >
          <MultiSelectField
            formKey={undefined}
            label={`Attached to ${getNominative(
              carePlanNominative,
              'Care Plans'
            )}`}
            customOnChange={this.handleCarePlanIds}
            onChange={() => {}}
            options={carePlanOptions || []}
            formatOptionLabel={this.carePlanSelectOption}
            customValues={this.state.carePlans}
            centerLabel
          />
        </div>
        {this.props.isRiskAssessmentFuturePlanEnabled && (
          <ContingencyPlanSelector
            residentId={this.props.router.params.id}
            selectedContingencyPlans={this.state.contingencyPlans}
            onChange={this.handleContingencyPlanIds}
            label="Attached to Future Plan"
          />
        )}
        {carePlansOptios && !carePlansChoosen ? (
          <Text style={{ color: colors.red }} as="p3">
            {passPortNote(carePlanNominative)}
          </Text>
        ) : null}
        {!carePlansOptios && !carePlansChoosen ? (
          <Text style={{ color: colors.red }} as="p3">
            {reviewCarePlanNote(carePlanNominative)}
          </Text>
        ) : null}
        <FormFields
          form={form}
          fields={fields}
          readOnly={false}
          userGenerated
        />
      </>
    )
  }

  renderOutcomesScore = () => {
    const { form, resident, risk } = this.props
    if (form && !form.hasRiskScore) return null
    return (
      <div style={styles.sectionContainer}>
        <div style={styles.titleContainer}>
          <IconSectionHeader
            icon="info"
            title="Risk Outcome Score"
            color={form.color || colors.darkblue}
          />
        </div>
        <div style={styles.fieldContainer}>
          <RiskAssessmentOutcome
            hasActions={form.hasActions}
            resident={resident}
            risk={risk}
          />
        </div>
      </div>
    )
  }

  renderActionsSection = () => {
    const { form, carePlanNominative } = this.props
    if (form && !form.hasActions) return null
    return (
      <div style={styles.sectionContainer}>
        <div style={styles.titleContainer}>
          <IconSectionHeader
            icon="actions"
            title="Actions to mitigate this risk"
            color={form.color || colors.darkblue}
          />
        </div>
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="lmc-card-edit"
              keys="actions"
              formId={FORM_ID}
              note={getActionsNote(carePlanNominative)}
              layout="no-label"
              required
              type="textarea"
              values={this.props.fields}
            />
          </Suspense>
        </div>
      </div>
    )
  }

  renderHeader() {
    const { errors, fields, form } = this.props

    return (
      <div>
        <div
          style={{
            marginLeft: isDesktop && !form.iconText ? 55 : 0
          }}
        >
          {fields && (fields.name || fields.name === '') ? (
            <AssessmentEditableHeader
              form={form}
              hasToggle
              onChange={this.setCustomName}
              value={fields.name}
            />
          ) : (
            <IconSectionHeader
              isMainHeader
              title={form.name}
              iconText={form.iconText}
              color={form.color}
            />
          )}
        </div>
        <ErrorBox
          errors={errors}
          style={{
            ...styles.errors,
            marginLeft: isDesktop ? 55 : 0
          }}
        />
      </div>
    )
  }

  renderModal = () => {
    const { carePlanNominative } = this.props

    const carePlansToDisplay = this.state.carePlans.filter(
      (carePlan) => !carePlan.noFurtherSupportRequired
    )
    const noCarePlansToDisplay = this.state.carePlans?.length

    return (
      <Modal
        localisation={{
          confirmText: 'Ok',
          cancelText: 'Cancel'
        }}
        onConfirm={() => this.handleSubmit()}
        onCancel={() => this.setState({ isModalVisible: false })}
        isModalVisible={this.state.isModalVisible}
        setIsModalVisible={() =>
          this.setState({ isModalVisible: !this.state.isModalVisible })
        }
      >
        <>
          <Text as="h5" style={{ color: colors.red }}>
            Please Note:
          </Text>
          <Text as="p2" style={{ marginBottom: 20 }}>
            {`Updating this risk assessment will require you to review the following ${getNominative(
              carePlanNominative,
              `${noCarePlansToDisplay > 1 ? 'Care Plans' : 'Care Plan'}`
            )}:`}
          </Text>
          <div style={{ marginTop: 10 }}>
            {!!noCarePlansToDisplay &&
              carePlansToDisplay?.map((carePlan) => (
                <div key={carePlan.id} style={{ display: 'flex' }}>
                  <ImageSection
                    popup
                    icon={carePlan?.icon}
                    iconColor={carePlan?.color}
                    iconText={carePlan?.iconText}
                  />
                  <Text as="h5" style={{ marginLeft: 5 }}>
                    {carePlan?.name}
                  </Text>
                </div>
              ))}
          </div>
        </>
      </Modal>
    )
  }

  handleSave = () => {
    const { initial } = this.props

    const fields = this.props?.fields

    const carePlansChoosen = this.state.carePlans?.length
    const hasFormChanges = !_.isEqual(fields, initial)
    const hasCarePlans = !!carePlansChoosen

    if ((hasCarePlans && hasFormChanges) || (this.hasChangedCarePlans() && hasCarePlans)) {
      this.setState({ isModalVisible: true })
    } else {
      this.handleSubmit()
    }
  }

  render() {
    const {
      carePlanAdls,
      fields,
      form,
      resident,
      style,
      onCancel,
      riskAssessmentId,
      archived
    } = this.props

    if (!carePlanAdls || !fields || !form || !resident) {
      return <Spinner />
    }

    return (
      <div id="lmc-risk-assessment-form" ref={this.setFormRef} style={style}>
        {this.renderHeader()}
        {this.renderFields()}
        {this.renderOutcomesScore()}
        {this.renderActionsSection()}
        {this.renderModal()}
        <RiskAssessmentEditFooter
          onCancel={onCancel}
          onSave={this.handleSave}
          isLoading={false}
          isEditing={!!riskAssessmentId}
          riskAssessmentId={riskAssessmentId}
          residentId={this.props.router.params.id}
          archived={archived}
        />
      </div>
    )
  }
}

const FORM_ID = 'createRiskAssessment'
const getActionsNote = (carePlanNominative) =>
  `Any text you include in this box will be copied into the ‘Actions’ box inside the ${getNominative(
    carePlanNominative,
    'Care Plan'
  )} when you save this Risk Assessment. To edit this text, you must return to this Risk Assessment.`

const passPortNote = (carePlanNominative) =>
  `Please Note: This risk assessment isn't connected to a ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}, so won't be attached in the hospital passport`

const reviewCarePlanNote = (carePlanNominative) =>
  `Please Note: You haven't reviewed any ${getNominative(
    carePlanNominative,
    'Care Plan'
  )} yet. You can attach this assessment to a ${getNominative(
    carePlanNominative,
    'Care Plan'
  )} during a review or come back here afterwards.`

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 20
  },
  cancelButton: {
    marginRight: 10
  },
  careplanSelector: {
    paddingBottom: 100
  },
  errors: {
    marginTop: 24
  },
  saveButton: {
    marginLeft: 10
  },
  titleContainer: {
    marginTop: 55
  },
  fieldContainer: {
    paddingTop: 24,
    marginLeft: 0
  },
  sectionHeaderContainer: {
    fontSize: 24,
    marginTop: 55,
    marginLeft: isDesktop ? 55 : 0,
    borderBottom: '2px solid',
    borderColor: colors.darkgrey
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex'
  }
}

RiskAssessmentForm.propTypes = {
  carePlanAdls: PropTypes.array,
  customName: PropTypes.string,
  form: PropTypes.object,
  formData: PropTypes.object,
  resident: PropTypes.object,
  risk: PropTypes.shape({
    level: PropTypes.oneOf([
      'na',
      'low',
      'medium',
      'high',
      'severe',
      'incomplete'
    ]).isRequired,
    score: PropTypes.number.isRequired
  }),
  riskAssessmentId: PropTypes.string
}

const mapStateToProps = (state, props) => {
  const residentId = props.router.params.id
  return {
    form: Selectors.formatFieldsForAssessment(state, props),
    resident: _.find(state.data.residents, { id: residentId }),
    carePlanAdls: state.data['care-plan-adls'],
    risk: Selectors.calculateAssessmentRisk(state, props),
    carePlanNominative: state.global.home.preferredCarePlansNominative,
    carePlans: state.carePlans,
    features: state.global.home
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchCarePlan: (id) => dispatch(Operations.fetchResidentAdls(id)),
  loadListItem: (list_id, item_id) =>
    dispatch(Operations.loadListItem(list_id, item_id)),
  addForm: (initial = {}) =>
    dispatch(
      Actions.addForm({
        formId: FORM_ID,
        initial
      })
    )
})

const wrappedForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RiskAssessmentForm)
)

export default Form(wrappedForm, FORM_ID)
